import { render, staticRenderFns } from "./pt-message-table-item.vue?vue&type=template&id=59749cec"
import script from "./pt-message-table-item.vue?vue&type=script&lang=js"
export * from "./pt-message-table-item.vue?vue&type=script&lang=js"
import style0 from "./pt-message-table-item.vue?vue&type=style&index=0&id=59749cec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports